import React from 'react'
import cn, { Argument as ClassName } from 'classnames'

export type ArrowIconProps = {
    color?: string
    width?: number
    height?: number
    className?: ClassName
    style?: React.CSSProperties
    ['data-testid']?: string
} & React.ComponentPropsWithRef<'svg'>

export function ArrowIcon({
    className,
    style,
    width = 20,
    height = 8,
    color = '#81E18B',
    ['data-testid']: dataTestid = 'arrow-icon',
}: ArrowIconProps): React.ReactElement {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={cn(className)}
            style={style}
            data-testid={dataTestid}
        >
            <path
                d="M0.340034 8L7.17003 1.17C7.93003 0.420001 8.93003 9.38046e-07 10 8.44504e-07C11.07 7.50962e-07 12.07 0.420001 12.83 1.17L19.66 8L16.82 8L11.41 2.59C10.66 1.83 9.34003 1.83 8.59003 2.59L3.18003 8L0.340034 8Z"
                fill={color}
            />
        </svg>
    )
}
